import type { SampleHandle } from "../types";

export const sampleIdsEqual = (
  id?: string | number,
  otherId?: string | number
) => {
  // Both undefined
  if (id === undefined && otherId === undefined) {
    return true;
  }

  // One undefined
  if (id === undefined || otherId === undefined) {
    return false;
  }

  // Treat both as strings for comparison
  return String(id) === String(otherId);
};

export const isCurrentSample = (
  handle: SampleHandle | undefined,
  id: string | number,
  epoch: number
): boolean =>
  handle !== undefined &&
  handle.epoch === epoch &&
  sampleIdsEqual(handle.id, id);

/**
 * Whether a row is the sample currently open in the detail route.
 *
 * Keyed off the route (undefined id/epoch means the log list is showing), not
 * the persisted highlightedSample — that lingers after navigating back to
 * the log, so using it would wrongly skip re-opening the same sample.
 */
export const isSampleOpenInRoute = (
  routeSampleId: string | undefined,
  routeEpoch: string | undefined,
  rowSampleId: string | number,
  rowEpoch: number
): boolean =>
  routeSampleId !== undefined &&
  routeEpoch !== undefined &&
  sampleIdsEqual(routeSampleId, rowSampleId) &&
  Number(routeEpoch) === rowEpoch;

export const sampleHandlesEqual = (
  sample1?: SampleHandle,
  sample2?: SampleHandle
): boolean => {
  if (!sample1 && !sample2) {
    return true;
  }

  if (!sample1 || !sample2) {
    return false;
  }

  return (
    sampleIdsEqual(sample1.id, sample2.id) &&
    sample1.epoch === sample2.epoch &&
    sample1.logFile === sample2.logFile
  );
};

export const createSampleHandle = (
  id: string | number,
  epoch: number,
  logFile: string
): SampleHandle => {
  return { id, epoch, logFile };
};
